import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";
import { formatDate, formatViews } from "@/lib/content";

export default function NewsCard({ news }: { news: NewsItem }) {
  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex flex-col sm:flex-row gap-4 md:gap-5 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="w-full sm:w-56 md:w-64 shrink-0 h-44 sm:h-36 md:h-40 rounded-md overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={`${news.title}配图`}
          title={`${news.title} - 筱田优影视资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
        />
      </div>
      <div className="flex-1 flex flex-col min-w-0">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
            {news.category}
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-calendar-line" />
            {formatDate(news.date)}
          </span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(news.views)}
          </span>
        </div>
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{news.excerpt}</p>
        <div className="flex items-center gap-2 mt-auto pt-3 flex-wrap">
          {news.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-xs text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded-md">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}